export default __webpack_public_path__ + "static/media/template10.bea70950.svg";